import { docodeHexResponse } from "../../_common/common.utils";
import CallBackTypes from "./callBack.types";
const INITIAL_STATE: any = {
  selectCallBackListResponseArr: [],
  selectCallBackListResponse: null,
  selectCallBackExportResponseArr: [],
  selectCallBackExportResponse: null,
  exportCallBackStatus: "",
};
const callBackReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case CallBackTypes.CALLBACK_FETCH_SUCCESS:
      return {
        ...state,
        selectCallBackListResponse: action.payload,
        selectCallBackListResponseArr: docodeHexResponse(
          action.payload,
          "CallBackKey",
        ),
      };

    case CallBackTypes.CALLBACK_FETCH_FAILURE:
      return {
        ...state,
        selectCallBackListResponse: action.payload,
        selectCallBackListResponseArr: [],
      };

    case CallBackTypes.CALLBACK_FETCH_CHANGED:
      return { ...state, selectCallBackListResponse: null };

    case CallBackTypes.CALLBACK_EXPORT_SUCCESS:
      return {
        ...state,
        selectCallBackExportResponse: action.payload,
        selectCallBackExportResponseArr: docodeHexResponse(
          action.payload,
          "CreateRequestReportKey",
        ),
        exportCallBackStatus: "Success",
      };

    case CallBackTypes.CALLBACK_EXPORT_FAILURE:
      return {
        ...state,
        selectCallBackExportResponse: action.payload,
        selectCallBackExportResponseArr: [],
        exportCallBackStatus: "Failure",
      };

    case CallBackTypes.CALLBACK_EXPORT_CHANGED:
      return {
        ...state,
        selectCallBackExportResponse: null,
        exportCallBackStatus: "",
      };

    default:
      return state;
  }
};
export default callBackReducer;
